(() => {
  if (window.PetgrossAuthorizedSellerLoaded) return;
  window.PetgrossAuthorizedSellerLoaded = true;

  let activeModal = null;
  let opener = null;

  const getFocusable = (modal) =>
    Array.from(
      modal.querySelectorAll(
        'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => !element.hasAttribute('hidden'));

  const openModal = (modal, trigger) => {
    if (!modal) return;

    // Pencereyi doğrudan body altına taşıyarak
    // logo, menü ve arama alanının üzerine çıkmasını engeller.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    activeModal = modal;
    opener = trigger;
    modal.hidden = false;
    document.body.classList.add('pg-authorized-modal-open');

    requestAnimationFrame(() => {
      modal.querySelector('[role="dialog"]')?.focus();
    });
  };

  const closeModal = () => {
    if (!activeModal) return;

    activeModal.hidden = true;
    document.body.classList.remove('pg-authorized-modal-open');

    const previousOpener = opener;

    activeModal = null;
    opener = null;

    previousOpener?.focus();
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest(
      '[data-pg-authorized-open]'
    );

    if (openButton) {
      const modalId = openButton.dataset.pgAuthorizedOpen;
      const modal = document.getElementById(modalId);

      openModal(modal, openButton);
      return;
    }

    if (event.target.closest('[data-pg-authorized-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!activeModal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = getFocusable(activeModal);

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (
      !event.shiftKey &&
      document.activeElement === last
    ) {
      event.preventDefault();
      first.focus();
    }
  });
})();